<template>
    <Teleport to="body">
        <div class="modal-bg-mask">
            <div class="confirm-modal">
                <div class="modal-header">
                    {{ this.$props.header }}
                </div>
                <div class="modal-msg" v-if="this.$props.msg">
                    {{ this.$props.msg }}
                </div>

                <div class="modal-btn-container" v-if="this.$props.showConfirm || this.$props.showCancel">
                    <div class="firm-btn" @click="onConfirm" v-if="this.$props.showConfirm === true">{{ this.$props.confirmTxt }}</div>
                    <div class="cancel-btn" v-if="this.$props.showCancel === true" @click="onCancel">{{ this.localize(this.$props.cancelTxt) }}</div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script>
export default {
    name: 'ConfirmModal',
    props: {
        header: String,
        msg: String,
        confirmTxt: String,
        cancelTxt: {
            type: String,
            default: '取消'
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        showConfirm: {
            type: Boolean,
            default: true
        }
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            orderList: []
        }
    },
    methods: {
        onConfirm() {
            this.$emit('confirm')
        },
        onCancel() {
            this.$emit('cancel')
        }
    }
}
</script>
<style scoped>
.confirm-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    min-width: 70%;
    max-height: 90%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2em;
    z-index: 1000;
    background-color: #254725;
    padding: 1em 2em;
    border-radius: 0.4em;
}

.modal-btn-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.modal-bg-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    /* 原本半透明背景色，可稍微提高以突顯模糊 */
    background-color: rgba(0, 0, 0, 0.35);

    /* 背景模糊 */
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);

    /* 可選：提升疊放層級，確保遮罩在上層 */
    z-index: 999;
}

.modal-header {
    font-size: 2em;
    color: #ffffff;
}

.firm-btn {
    font-size: 2em;
    padding: 0.2em 0.6em;
    border: 2px solid #ffffff;
    border-radius: 0.4em;
    color: #ffffff;
}
</style>